var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptybox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 42.0856L12.5625 30.523L37.2293 42.0856L64.2086 30.523L75.0003 39.0022L65.7503 43.1134V65.2107L37.2293 76.0024L8.70837 65.2107V45.2596L1 42.0856Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8126 27.4397L12.5625 30.523M12.5625 30.523L1 42.0856L8.70837 45.2596M12.5625 30.523L37.2293 42.0856M37.2293 42.0856L27.2084 52.8773L8.70837 45.2596M37.2293 42.0856L47.2502 51.3356L65.7503 43.1134M37.2293 42.0856L64.2086 30.523M37.2293 42.0856V76.0024M64.2086 30.523L75.0003 39.0022L65.7503 43.1134M64.2086 30.523L52.6461 27.4397M37.2293 76.0024L65.7503 65.2107V43.1134M37.2293 76.0024L8.70837 65.2107V45.2596",
    stroke: "#B9B9B9",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 7.00024L43.0067 16.339L54 18.4592L46.41 26.3511L47.6976 37.0002L37.5 32.539L27.3024 37.0002L28.4093 27.8453L28.59 26.3511L21 18.4592L31.9933 16.339L37.5 7.00024Z",
    fill: "#F2CA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37 1.00024V4.00024",
    stroke: "#B9B9B9",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6177 7.72583L47.2218 9.53128",
    stroke: "#B9B9B9",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3828 7.72485L27.7787 9.5303",
    stroke: "#B9B9B9",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptybox);
export default __webpack_public_path__ + "static/media/emptybox.746672984e793f6ad624323e0473148e.svg";
export { ForwardRef as ReactComponent };